import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AuthComponent} from './auth/auth.component';
import {SettingsComponent} from './settings/settings.component';
import {SettingsUsersComponent} from './settings-users/settings-users.component';
import {SettingsTranslationsComponent} from './settings-translations/settings-translations.component';
import {SettingsPermissionsComponent} from './settings-permissions/settings-permissions.component';
import {AuthGuard, NoAuthGuard} from '../core';
import {VariantsComponent} from './variants/variants.component';
import {VariantEditComponent} from './variant-edit/variant-edit.component';
import {PagesComponent} from './pages/pages.component';
import {MediaComponent} from './media/media.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {RestorePasswordComponent} from './restore-password/restore-password.component';
import {ConfigurationComponent} from './configuration/configuration.component';
import {SettingsMarketsComponent} from './settings-markets/settings-markets.component';
import {SettingsProductSettingsComponent} from './settings-product-settings/settings-product-settings.component';
import {ConfigurationProductsComponent} from './configuration-products/configuration-products.component';
import {ConfigurationVariantGroupsComponent} from './configuration-variant-groups/configuration-variant-groups.component';
import {ConfigurationNavigationComponent} from './configuration-navigation/configuration-navigation.component';
import {ConfigurationCategoriesComponent} from './configuration-categories/configuration-categories.component';
import {ConfigurationSubcategoriesComponent} from './configuration-subcategories/configuration-subcategories.component';
import {ConfigurationViewsComponent} from './configuration-views/configuration-views.component';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {PluginGotenehusMappingComponent} from './plugin-gotenehus-mapping/plugin-gotenehus-mapping.component';
import {PluginGotenehusMappingDataComponent} from './plugin-gotenehus-mapping-data/plugin-gotenehus-mapping-data.component';
import {PluginGotenehusProductRegionsComponent} from './plugin-gotenehus-product-regions/plugin-gotenehus-product-regions.component';
import {PluginGotenehusRegionsComponent} from './plugin-gotenehus-regions/plugin-gotenehus-regions.component';

const routes: Routes = [
    {
        path: '',
        component: SettingsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.settings.title'
        }
    },
    {
        path: 'configuration',
        canActivate: [AuthGuard],
        children: [
            {path: '', redirectTo: '/configuration/products', pathMatch: 'full'},
            {
                path: 'products',
                component: ConfigurationProductsComponent,
                data: {
                    title: 'webpanel.pages.configuration-products.title',
                },
            },
            {
                path: 'navigation',
                component: ConfigurationNavigationComponent,
                data: {
                    title: 'webpanel.pages.configuration-navigation.title',
                },
            },
            {
                path: 'categories',
                component: ConfigurationCategoriesComponent,
                data: {
                    title: 'webpanel.pages.configuration-categories.title',
                },
            },
            {
                path: 'subcategories',
                component: ConfigurationSubcategoriesComponent,
                data: {
                    title: 'webpanel.pages.configuration-subcategories.title',
                },
            },
            {
                path: 'views',
                component: ConfigurationViewsComponent,
                data: {
                    title: 'webpanel.pages.configuration-views.title',
                },
            },
            {
                path: 'variant-groups',
                component: ConfigurationVariantGroupsComponent,
                data: {
                    title: 'webpanel.pages.configuration-variant-groups.title',
                },
            },
        ]
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.settings.title'
        }
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.dashboard.title'
        }
    },
    {
        path: 'plugin-gotenehus-mapping',
        component: PluginGotenehusMappingComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.plugin-gotenehus-mapping.title'
        }
    },
    {
        path: 'plugin-gotenehus-mapping-data',
        component: PluginGotenehusMappingDataComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.plugin-gotenehus-mapping-data.title'
        }
    },
    {
        path: 'plugin-gotenehus-regions',
        component: PluginGotenehusRegionsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.plugin-gotenehus-regions.title'
        }
    },
    {
        path: 'plugin-gotenehus-product-regions',
        component: PluginGotenehusProductRegionsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.plugin-gotenehus-product-regions.title'
        }
    },
    {
        path: 'settings-users',
        component: SettingsUsersComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.settings-users.title'
        }
    },
    {
        path: 'settings-translations',
        component: SettingsTranslationsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.translations.title'
        }
    },
    {
        path: 'settings-permissions',
        component: SettingsPermissionsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.permissions.title'
        }
    },
    {
        path: 'settings-markets',
        component: SettingsMarketsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.markets.title'
        }
    },
    // {
    //     path: 'products',
    //     component: ProductsComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         title: 'webpanel.pages.products.title'
    //     }
    // },
    {
        path: 'settings-product-settings',
        component: SettingsProductSettingsComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.settings_product_settings.title'
        }
    },
    {
        path: 'variants',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: VariantsComponent,
                data: {
                    title: 'webpanel.pages.variants.title'
                },
            },
            {
                path: ':id',
                component: VariantEditComponent,
                data: {
                    title: 'webpanel.pages.variant-edit.title'
                }
            }
        ]
    },
    {
        path: 'pages',
        component: PagesComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.pages.title'
        }
    },
    {
        path: 'media',
        component: MediaComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'webpanel.pages.media.title'
        }
    },
    {
        path: 'login',
        component: AuthComponent,
        canActivate: [NoAuthGuard],
        data: {
            title: 'webpanel.pages.login.title'
        }
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [NoAuthGuard],
        data: {
            title: 'webpanel.pages.resetPassword.title'
        }
    },
    {
        path: 'restore-password',
        component: RestorePasswordComponent,
        canActivate: [NoAuthGuard],
        data: {
            title: 'webpanel.pages.restorePassword.title'
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRouting {
}



// WEBPACK FOOTER //
// ./src/app/pages/pages-routing.ts